import ServiceDetailPage from "@/components/ServiceDetailPage";

const Ecommerce = () => <ServiceDetailPage pageKey="ecommerce" />;

export default Ecommerce;
